import { createAction } from "redux-actions";
import {GET_CERTIFICATES } from "../constants";
import { feathersCreateData } from "../services";

export const getCertificatesCore = createAction(GET_CERTIFICATES, (SecuencialEmpresa) => feathersCreateData('core-server',{
    service: 'CERTIFICATES',
    func: 'GET_CERTIFICATE_TYPES',
    data: {SecuencialEmpresa}
})())
